module.exports = __webpack_public_path__ + "static/img/gaozhongdili7.a90780f6.jpg";